import { addMedia } from "../utils/media-utils";
import { SOUND_SPAWN_EMOJI } from "../systems/sound-effects-system";
import emoji0Particle from "../assets/images/emojis/emoji_0.png";
import emoji1Particle from "../assets/images/emojis/emoji_1.png";
import emoji3Particle from "../assets/images/emojis/emoji_3.png";
import emoji5Particle from "../assets/images/emojis/emoji_5.png";
import emoji6Particle from "../assets/images/emojis/emoji_6.png";
import emoji7Particle from "../assets/images/emojis/emoji_7.png";
import emoji8Particle from "../assets/images/emojis/emoji_8.png";
import emoji9Particle from "../assets/images/emojis/emoji_9.png";
import emoji10Particle from "../assets/images/emojis/emoji_10.png";
import emoji11Particle from "../assets/images/emojis/emoji_11.png";
import emoji12Particle from "../assets/images/emojis/emoji_12.png";
import emoji13Particle from "../assets/images/emojis/emoji_13.png";
import emoji14Particle from "../assets/images/emojis/emoji_14.png";
import emoji15Particle from "../assets/images/emojis/emoji_15.png";
import emoji16Particle from "../assets/images/emojis/emoji_16.png";
import emoji17Particle from "../assets/images/emojis/emoji_17.png";
import emoji18Particle from "../assets/images/emojis/emoji_18.png";
import emoji19Particle from "../assets/images/emojis/emoji_19.png";

import emoji0Model from "../assets/models/emojis/emoji_0.glb";
import emoji1Model from "../assets/models/emojis/emoji_1.glb";
import emoji3Model from "../assets/models/emojis/emoji_3.glb";
import emoji5Model from "../assets/models/emojis/emoji_5.glb";
import emoji6Model from "../assets/models/emojis/emoji_6.glb";
import emoji7Model from "../assets/models/emojis/emoji_7.glb";
import emoji8Model from "../assets/models/emojis/emoji_8.glb";
import emoji9Model from "../assets/models/emojis/emoji_9.glb";
import emoji10Model from "../assets/models/emojis/emoji_10.glb";
import emoji11Model from "../assets/models/emojis/emoji_11.glb";
import emoji12Model from "../assets/models/emojis/emoji_12.glb";
import emoji13Model from "../assets/models/emojis/emoji_13.glb";
import emoji14Model from "../assets/models/emojis/emoji_14.glb";
import emoji15Model from "../assets/models/emojis/emoji_15.glb";
import emoji16Model from "../assets/models/emojis/emoji_16.glb";
import emoji17Model from "../assets/models/emojis/emoji_17.glb";
import emoji18Model from "../assets/models/emojis/emoji_18.glb";
import emoji19Model from "../assets/models/emojis/emoji_19.glb";

export const emojis = [
  // Hands
  { id: "applause", model: emoji13Model, particle: emoji13Particle, icon: "👏" },
  { id: "greeting", model: emoji15Model, particle: emoji15Particle, icon: "👋" },
  { id: "like", model: emoji16Model, particle: emoji16Particle, icon: "👍" },
  { id: "dislike", model: emoji14Model, particle: emoji14Particle, icon: "👎" },
  { id: "strength", model: emoji17Model, particle: emoji17Particle, icon: "💪" },
  { id: "thank_you", model: emoji18Model, particle: emoji18Particle, icon: "🙏" },
  { id: "victory", model: emoji19Model, particle: emoji19Particle, icon: "✌️" },

  // Faces
  { id: "smile", model: emoji0Model, particle: emoji0Particle, icon: "😀" },
  { id: "laugh", model: emoji1Model, particle: emoji1Particle, icon: "😄" },
  { id: "heart", model: emoji3Model, particle: emoji3Particle, icon: "😍" },
  { id: "angry", model: emoji5Model, particle: emoji5Particle, icon: "😡" },
  { id: "cry", model: emoji6Model, particle: emoji6Particle, icon: "😢" },
  { id: "tired", model: emoji7Model, particle: emoji7Particle, icon: "😫" },
  { id: "tongue", model: emoji8Model, particle: emoji8Particle, icon: "😜" },
  { id: "triumph", model: emoji9Model, particle: emoji9Particle, icon: "😤" },
  { id: "wink", model: emoji10Model, particle: emoji10Particle, icon: "😉" },
  { id: "worried", model: emoji11Model, particle: emoji11Particle, icon: "😲" },
  { id: "yum", model: emoji12Model, particle: emoji12Particle, icon: "😋" }
].map(({ model, particle, ...rest }) => {
  return {
    ...rest,
    model: new URL(model, window.location).href,
    particleEmitterConfig: {
      src: new URL(particle, window.location).href,
      resolve: false,
      particleCount: 20,
      startSize: 0.01,
      endSize: 0.2,
      sizeRandomness: 0.05,
      lifetime: 1,
      lifetimeRandomness: 0.2,
      ageRandomness: 1,
      startVelocity: { x: 0, y: 1, z: 0 },
      endVelocity: { x: 0, y: 0.25, z: 0 },
      startOpacity: 1,
      middleOpacity: 1,
      endOpacity: 0
    }
  };
});

export function spawnEmojiInFrontOfUser({ model, particleEmitterConfig }) {
  const { entity } = addMedia(model, "#interactable-emoji");
  entity.setAttribute("offset-relative-to", {
    target: "#avatar-pov-node",
    offset: { x: 0, y: 0, z: -3 }
  });
  entity.addEventListener("model-loaded", () => {
    entity.querySelector(".particle-emitter").setAttribute("particle-emitter", particleEmitterConfig);
    entity.setAttribute("emoji", { particleEmitterConfig: particleEmitterConfig });
  });
}

AFRAME.registerComponent("emoji", {
  schema: {
    emitDecayTime: { default: 1.5 },
    emitFadeTime: { default: 0.5 },
    emitEndTime: { default: 0 },
    particleEmitterConfig: {
      default: null,
      parse: v => (typeof v === "object" ? v : JSON.parse(v)),
      stringify: JSON.stringify
    }
  },

  init() {
    this.data.emitEndTime = performance.now() + this.data.emitDecayTime * 1000;
    this.physicsSystem = this.el.sceneEl.systems["hubs-systems"].physicsSystem;
  },

  play() {
    const mediaLoader = this.el.components["media-loader"];
    if (emojis.find(emoji => emoji.model !== mediaLoader.data.src) === -1) {
      this.el.parentNode.removeChild(this.el);
      return;
    }

    this.el.sceneEl.systems["hubs-systems"].soundEffectsSystem.playPositionalSoundFollowing(
      SOUND_SPAWN_EMOJI,
      this.el.object3D
    );
    this.particleEmitter = this.el.querySelector(".particle-emitter");
  },

  update() {
    if (!this.particleConfig && this.data.particleEmitterConfig) {
      this.particleConfig = Object.assign({}, this.data.particleEmitterConfig);
      this.originalParticleCount = this.particleConfig.particleCount;
    }
  },

  tick() {
    const isMine = this.el.components.networked.initialized && this.el.components.networked.isMine();

    if (this.particleConfig && isMine) {
      const now = performance.now();

      const isHeld = this.el.sceneEl.systems.interaction.isHeld(this.el);

      if (isHeld) {
        this.data.emitEndTime = now + this.data.emitDecayTime * 1000;
      }

      const emitFadeTime = this.data.emitFadeTime * 1000;

      if (now < this.data.emitEndTime && this.particleConfig.startOpacity < 1) {
        this.particleConfig.particleCount = this.originalParticleCount;
        this.particleConfig.startOpacity = 1;
        this.particleConfig.middleOpacity = 1;
        this.particleEmitter.setAttribute("particle-emitter", this.particleConfig, true);
      } else if (now >= this.data.emitEndTime && this.particleConfig.startOpacity > 0.001) {
        const timeSinceStop = Math.min(now - this.data.emitEndTime, emitFadeTime);
        const opacity = 1 - timeSinceStop / emitFadeTime;
        const particleCount = opacity < 0.001 && this.particleConfig.particleCount > 0 ? 0 : this.originalParticleCount;
        this.particleConfig.particleCount = particleCount;
        this.particleConfig.startOpacity = opacity;
        this.particleConfig.middleOpacity = opacity;
        this.particleEmitter.setAttribute("particle-emitter", this.particleConfig, true);
      }
    }
  }
});
